import { handleActions } from 'redux-actions';
import { DeviceMap } from 'types';
import {
    DevicesLoadRequestAction,
    DevicesLoadSuccessAction,
    DevicesLoadFailureAction,
    DevicesChangedAction,
} from 'actions/deviceActions';
import { LogoutAction } from 'actions/shellActions';
import { deepEqual } from 'util/deepEqual';

export type State = Readonly<{
    data: Readonly<DeviceMap> | null;
    loading: boolean;
    error: Error | null;
}>;

export const initialState = Object.freeze<State>({
    data: null,
    loading: false,
    error: null,
});

export type ReducerAction =
    DevicesLoadRequestAction
    | DevicesLoadSuccessAction
    | DevicesLoadFailureAction
    | DevicesChangedAction
    // Shell Actions
    | LogoutAction
;

export type Reducer = (state: State, action: ReducerAction) => State;

const updateDevicesOnlyIfChanged = (existing: Readonly<DeviceMap>, incoming: Readonly<DeviceMap>): Readonly<DeviceMap> => {
    const existingKeys = Object.keys(existing);
    if (existingKeys.length === 0) {
        return incoming;
    }

    let unchangedCount = 0;

    const devices: DeviceMap = { ...incoming };
    const incomingKeys = Object.keys(incoming);
    incomingKeys.forEach(deviceId => {
        if (deepEqual(incoming[deviceId], existing[deviceId])) {
            devices[deviceId] = existing[deviceId];
            unchangedCount++;
        }
    });

    // Maintain the existing reference if nothing changed at all
    if (incomingKeys.length === unchangedCount &&
        existingKeys.length === unchangedCount) {
        return existing;
    }

    return devices;
};

export const deviceReducer: Reducer = handleActions({
    DEVICES_LOAD_REQUEST(state: State, action: DevicesLoadRequestAction) {
        return {
            ...state,
            loading: true,
            error: null,
        };
    },

    DEVICES_LOAD_SUCCESS(state: State, action: DevicesLoadSuccessAction) {
        const { cameras = {}, accessDevices = {} } = action.payload;
        const data = updateDevicesOnlyIfChanged(state.data || {}, { ...cameras, ...accessDevices });
        return {
            ...state,
            data,
            loading: false,
            error: null,
        };
    },

    DEVICES_LOAD_FAILURE(state: State, action: DevicesLoadFailureAction) {
        return {
            ...state,
            loading: false,
            error: action.payload,
        };
    },

    /* TODO
    DEVICES_CHANGED(state: State, action: DevicesChangedAction) {

    },
    */


    //
    //  Shell Actions
    //
    LOGOUT(state: State, action: LogoutAction) {
        return initialState;
    },

// tslint:disable-next-line:no-any
} as any, initialState) as any;



// WEBPACK FOOTER //
// ./src/reducers/deviceReducer.ts